const ROOT = '/' as const;
const LOGIN = '/login' as const;
const FORGOT_PASSWORD = '/forgot-password' as const;
const CHANGE_PASSWORD = `/change-password/:token/:userId` as const;
const SIGN_UP = '/sign-up' as const;
const USER_PROFILE = '/user-profile' as const;
const APPOINTMENTS = '/appointments' as const;
const CREATE_APPOINTMENT = `${APPOINTMENTS}/create` as const;
const EDIT_APPOINTMENT = `${APPOINTMENTS}/:id` as const;
const APPOINTMENT_DETAILS = `${APPOINTMENTS}/:id/details` as const;
const PROPOSALS = '/proposals' as const;
const CREATE_PROPOSAL = `${PROPOSALS}/create/:appointmentId` as const;
const EDIT_PROPOSAL = `${PROPOSALS}/:id` as const;
const INVOICES = '/invoices' as const;
const CREATE_INVOICE = `${INVOICES}/create/:appointmentId` as const;
const EDIT_INVOICE = `${INVOICES}/:appointmentId/:invoiceId` as const;
const DASHBOARD = '/dashboard' as const;
const USERS = '/users' as const;
const USER_CREATE = `${USERS}/create` as const;
const USER_UPDATE = `${USERS}/:id` as const;
const ADMIN_SETTINGS = `/settings` as const;
const ADMIN_SETTINGS_HOME_PAGE = `${ADMIN_SETTINGS}/home-page` as const;
const CREATE_HOME_PAGE = `${ADMIN_SETTINGS_HOME_PAGE}/create` as const;
const EDIT_HOME_PAGE = `${ADMIN_SETTINGS_HOME_PAGE}/edit/:id` as const;

export const PATH = {
    ROOT,
    LOGIN,
    FORGOT_PASSWORD,
    CHANGE_PASSWORD,
    SIGN_UP,
    USER_PROFILE,
    APPOINTMENTS,
    CREATE_APPOINTMENT,
    EDIT_APPOINTMENT,
    APPOINTMENT_DETAILS,
    PROPOSALS,
    CREATE_PROPOSAL,
    EDIT_PROPOSAL,
    INVOICES,
    CREATE_INVOICE,
    EDIT_INVOICE,
    DASHBOARD,
    USERS,
    USER_CREATE,
    USER_UPDATE,
    ADMIN_SETTINGS,
    ADMIN_SETTINGS_HOME_PAGE,
    CREATE_HOME_PAGE,
    EDIT_HOME_PAGE,
};
